import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=114bcbfb&scoped=true"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSettings.vue?vue&type=style&index=0&id=114bcbfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114bcbfb",
  null
  
)

export default component.exports